// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.webmapp-register-modalsave-footer {
  text-align: center;
  height: 130px;
}
.webmapp-register-modalsave-footer .webmapp-register-modalsave-savebtn {
  --border-radius: 22px;
  --padding-start: 100px;
  --padding-end: 100px;
  font-weight: var(--wm-font-weight-bold);
  margin: 20px;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);
  border-radius: 32px;
}
.webmapp-register-modalsave-footer .webmapp-register-modalsave-deletebtn {
  display: inline-block;
  color: var(--wm-color-darkgrey);
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/modal-save/modal-save.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,aAAA;AADF;AAGE;EACE,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,uCAAA;EACA,YAAA;ECVF,2CAAA;EDYE,mBAAA;AADJ;AAKE;EACE,qBAAA;EACA,+BAAA;AAHJ","sourcesContent":["@import 'src/theme/mixins.scss';\n\n.webmapp-register-modalsave-footer {\n  text-align: center;\n  height: 130px;\n\n  .webmapp-register-modalsave-savebtn {\n    --border-radius: 22px;\n    --padding-start: 100px;\n    --padding-end: 100px;\n    font-weight: var(--wm-font-weight-bold);\n    margin: 20px;\n    @include box-shadow-light;\n    border-radius: 32px;\n    // letter-spacing: 1px;\n  }\n\n  .webmapp-register-modalsave-deletebtn {\n    display: inline-block;\n    color: var(--wm-color-darkgrey);\n  }\n}\n","@mixin box-shadow-light {\n  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);\n}\n\n@mixin box-shadow-dark {\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.4);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
